import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { useAsyncThrow } from '../../hooks/useAsyncThrow';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from '../selectors/getOnsaCurrentProductSelector';
import type { CoveragePackageInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import {
    getCoveragePackageFieldsToUpdate,
    getLobToUpdate,
    getOnsaCoverable
} from '../../utils/coverablesUtil';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';

export function useSaveSelectedPackage(
    branchNumber: number,
    packageGroupName: string
): {
    savePackage: (branchNumber: number, packageGroupName: string) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName, fixedId, lobCode } = currentProduct ?? {};
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId);
    const { asyncThrow } = useAsyncThrow();
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const savePackage = async (): Promise<void> => {
        const fieldToUpdate: CoveragePackageInformationToUpdateDTO = {
            productToUpdate: flavourName,
            [getLobToUpdate(flavourName)]: getCoveragePackageFieldsToUpdate(coverable)
        };
        await OnlineSalesUnauthenticated.saveSelectedPackage(
            jobNumber,
            branchNumber,
            lobCode,
            fixedId,
            packageGroupName,
            fieldToUpdate,
            sessionId,
            !isLoggedOn
        ).catch(asyncThrow);
    };

    return { savePackage };
}
